import { createAction } from 'lib/store-utils';
import { OpenModalPayload } from './types';

export const BOX_WARNINGS_OPEN_MODAL = createAction<OpenModalPayload>('Warnings / open modal');
export const BOX_WARNINGS_CLOSE_MODAL = createAction('Warnings / close modal');
